import React, { Component } from 'react'
import { Button, Form, Input, Select, DatePicker, message, Modal, Card } from 'antd'
import NumberFormat from 'react-number-format'
import {connect} from 'dva'
import {Link} from 'dva/router'
import { all, create, get } from '../../services/restApi'
import moment from 'moment'
import PropTypes from 'prop-types'
const _ = require('underscore')

const FormItem = Form.Item;
const Option = Select.Option;
const RangePicker = DatePicker.RangePicker;
const TextArea = Input.TextArea;
const confirm = Modal.confirm

class InvoiceNew extends Component {

    constructor (props) {
        super(props);

        this.state = {
            loading: false,
            invoice: {},
            hotels: [],
            clients: [],
            filterByHotel: '',
            showModalClientDetails: false
        }

        if (localStorage.getItem('currentHotel') && JSON.parse(localStorage.getItem('currentHotel')).objectId) 
            this.state = {...this.state, currentHotel: JSON.parse(localStorage.getItem('currentHotel'))};

        message.config({top: 110, duration: 4});
    }


    /**
    * Inicializa los valores, según si se está creando o editando un registro
    */
    componentDidMount () {
        if (this.props.params.invoiceId) {
            // Inicialización de valores para actualizar

            this.props.dispatch({type: 'app/showLoading'})

            get('Invoice', this.props.params.invoiceId, {include: 'client,client.hotel'}).then((resp) => {
                let data = {...resp};

                if (resp.client) {
                    // Consulta los clientes
                    all('Client', {where: {objectId: data.client.objectId}, limit: 20}).then((clientData) => {
                        this.setState({
                            clients: clientData.results
                        });
                    })

                    // Consulta los hoteles
                    all('Hotel', {where: {objectId: data.client.hotel.objectId}, limit: 20}).then((hotelData) => {
                        this.setState({
                            hotels: hotelData.results
                        });

                        if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});
                    })

                    resp.hotel = {key: data.client.hotel.objectId, label: data.client.hotel.name};
                    resp.client = {key: data.client.objectId, label: data.client.name};
                }

                resp.checkin_checkout = [
                    moment(new Date(resp.checkin.iso), 'YYYY/MM/DD HH:mm'),
                    moment(new Date(resp.checkout.iso), 'YYYY/MM/DD HH:mm'),
                ];
                resp = _.omit(resp, ['checkin', 'checkout']);
                
                this.props.form.setFieldsValue(resp);
                this.setState({ invoice: resp });

                this.props.dispatch({type: 'app/hideLoading'})
            })

        } else {
            // Inicialización de valores para crear

            if (this.props.params.clientId) {
                get('Client', this.props.params.clientId).then((resp) => {

                    // Consulta los clientes, mandando el objectId del cliente actual
                    all('Client', {where: {objectId: resp.objectId}, limit: 20}).then((clientData) => {
                        this.setState({
                            clients: clientData.results
                        });
                    })

                    // Consulta los hoteles, mandando el objectId del cliente actual
                    all('Hotel', {where: {objectId: resp.hotel.objectId}, limit: 20}).then((hotelData) => {
                        if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});
                        this.setState({
                            hotels: hotelData.results
                        });
                    })

                    this.props.form.setFieldsValue({
                        client: {key: resp.objectId, label: resp.name},
                        hotel: {key: resp.hotel.objectId, label: resp.hotel.name}
                    });
                    this.setState({client: resp});
                });

            } else {

                // Query
                let queryClient = {};
                if (this.state.currentHotel)
                    queryClient.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

                // Consulta los clientes
                all('Client', {where: queryClient, limit: 20}).then((resp) => {
                    console.log(resp);
                    this.setState({
                        clients: resp.results
                    });
                })

                let queryHotel = {};
                if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
                    queryHotel.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
                }

                // Consulta los hoteles
                all('Hotel', {where: queryHotel, limit: 20}).then((resp) => {
                    if (this.state.currentHotel) this.props.form.setFieldsValue({hotel: {key: this.state.currentHotel.objectId, label: this.state.currentHotel.name}});
                    this.setState({
                        hotels: resp.results
                    });
                })
            }
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Hotel
    */
    fetchHotel (value, callback) {

        let query = { name: {$regex: '(?i)' + value} };

        if (this.props.app.user.type === 'recepcionista' || this.props.app.user.type === 'gerente') {
            query.objectId = {$in: _.pluck(this.props.app.user.hotels, 'objectId')}
        }

        setTimeout(() => {
            all('Hotel', {where: query}).then((d) => {
                const results = d.results;
                const hotels = [];
                
                results.forEach((r) => {
                    hotels.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(hotels);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectHotelChange (value) {
        this.props.form.setFieldsValue({ client: {key: ''} });      

        // Key trae el nombre del hotel que no está en la lista, entonces se consulta si está en la bd
        if (value && value.key && !value.label) {
            this.fetchHotel(value.key, (resp) => {
                this.setState({ hotels: resp })
            });
        }

        // Key trae el ID del hotel, entonces se consulta los clientes de dicho hotel
        if (value && value.key && value.label) {
            this.setState({ filterByHotel: value.key })

            setTimeout(() => {
                // No mandamos el primer parámetro ya que corresponde al Key que trae un nombre de cliente
                // en éste caso no estamos consultando por nombre sino por hotel
                this.fetchClient('', (clients) => {
                    this.setState({ clients: clients })
                });
            }, 100);
        }
    }


    /**
    * Encuentra las coincidencias según la cadena del input Cliente
    */
    fetchClient (value, callback) {
        // Query
        let query = {name: {$regex: '(?i)' + value}};
        if (this.state.currentHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.currentHotel.objectId}

        if (this.state.filterByHotel)
            query.hotel = {__type: 'Pointer', className: 'Hotel', objectId: this.state.filterByHotel}

        setTimeout(() => {
            all('Client', {where: query}).then((d) => {
                const results = d.results;
                const clients = [];
                
                results.forEach((r) => {
                    clients.push({
                        objectId: r.objectId,
                        name: r.name,
                    });
                });

                callback(clients);
            });
        }, 500);
    }


    /**
    * Asigna los nuevos valores traidos de la consulta de coincidencias
    */
    handleSelectClientChange (value) {
        // Key trae el nombre del cliente que no está en la lista, entonces se consulta si está en la bd
        if (value && value.key && !value.label) {
            this.fetchClient(value.key, (resp) => {
                this.setState({ clients: resp })
            });
        }
    }


    /**
    * Validator: Checa el correcto formato del teléfono
    */
    checkPhone (rule, value, callback) {
        if (value && value.replace(/[^\d.]/g, '').length < 10) {
            callback('Por favor, ingrese un número de teléfono válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa el correcto formato del celular
    */
    checkEmail (rule, value, callback) {
        const re = /^\w+@[a-zA-Z_]+?\.[a-zA-Z]{2,3}$/; 
        if (value && value.length > 0 && !re.test(value[value.length - 1])) {
            callback('Por favor, ingrese un correo electrónico válido!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkHotel (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el hotel al que pertenece el cliente!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que se haya elegido un hotel de la lista
    */
    checkClient (rule, value, callback) {
        if (value && !value.label) {
            callback('Por favor, elija el cliente al que pertenece la factura!');
        } else {
            callback();
        }
    }


    /**
    * Validator: Checa que el monto sea mayor a 0
    */
    checkAmount (rule, value, callback) {
        if (value && !_.isNumber(value) && Number(value.replace(/[^\d.]/g, '')) === 0) {
            callback('Por favor, ingrese el monto a facturar!');
        } else {
            callback();
        }
    } 


    /**
    * Muestra el modal de los detalles del cliente
    */
    showClientDetails () {
        this.props.dispatch({type: 'app/showLoading'})

        get('Client', this.props.form.getFieldValue('client').key).then((resp) => {

            this.setState({ currentClient: resp });
            this.props.dispatch({type: 'app/hideLoading'})
            this.setState({ showModalClientDetails: true });

        }).catch(e => {
            this.props.dispatch({type: 'app/hideLoading'})
            message.error('Ha ocurrido un error al consultar la información. Intente más tarde')    
        });
    }

    hideModalClientDetails () { this.setState({ showModalClientDetails: false }); }


    /**
    * Envío del formulario
    */
    handleSubmit (e) {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((errors, values) => {
            if (errors) { return }

            // Model
            let data = {...values};
            data.finished = false;
            data.client = {__type: 'Pointer', className: 'Client', objectId: values.client.key};
            data.checkin = {__type: 'Date', iso: new Date(values.checkin_checkout[0]).toISOString()};
            data.checkout = {__type: 'Date', iso: new Date(values.checkin_checkout[1]).toISOString()};
            data.amount = _.isNumber(values.amount) ? data.amount = values.amount : data.amount = Number(values.amount.replace(/[^\d.]/g, ''));
            data.createdBy = {__type: 'Pointer', className: '_User', objectId: this.props.app.user.objectId};
            data = _.omit(data, ['checkin_checkout', 'hotel']);
            
            if (!this.props.params.invoiceId) {
                // CREA
                
                this.props.dispatch({type: 'app/showButtonLoading'})

                create('Invoice', data).then(resp => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    this.props.form.setFieldsValue({amount: ''});
                    this.props.form.resetFields();

                    let context = this.context
                    confirm({
                        title: '¿Desea generar otra factura? Precione "Aceptar" para SI o cancelar para NO',
                        onCancel () {
                            context.router.push('/invoices/list-invoices');
                        }
                    }) 

                }).catch(e => {
                    this.props.dispatch({type: 'app/hideButtonLoading'})

                    if (e && e.data) message.error(e.data.error);
                    else message.error('Ha ocurrido un error. Intente más tarde')    
                });

            } else {
                // ACTUALIZA

                // Model
                _.extend(this.state.invoice, data);
                this.setState({ client: {__type: 'Pointer', className: 'Client', objectId: values.client.key, name: values.client.label} });
                this.state.invoice = _.omit(this.state.invoice, ['checkin_checkout']);

                this.props.dispatch({type: 'invoice/update', payload: this.state.invoice})
                this.context.router.goBack();
            }
        })
    }


    /**
    * Render del componente
    */
    render () {
        const hotel_options = this.state.hotels.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)
        const client_options = this.state.clients.map(d => <Option key={d.objectId} label={d.name}>{d.name}</Option>)

        return (
            <div className="content-wrapper">
                <section className="content-header">
                    <h1>
                        {this.state.invoice.objectId
                            ? <Link to="/invoices/list-invoices"><i className="fa fa-arrow-circle-left"></i></Link>
                            : ''
                        }
                        Factura
                    </h1>
                </section>

                <section className="content">
                    <Form onSubmit={this.handleSubmit.bind(this)}>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos del Cliente
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    {!this.state.currentHotel
                                        ? <div className="col-md-4">
                                            <FormItem label="Filtrar clientes por hotel" hasFeedback>
                                                {this.props.form.getFieldDecorator('hotel', {
                                                    rules: [{
                                                        required: false,
                                                    }, {
                                                        validator: this.checkHotel.bind(this)
                                                    }]
                                                })(
                                                    <Select 
                                                        size='large'
                                                        mode="combobox"
                                                        onChange={this.handleSelectHotelChange.bind(this)}
                                                        filterOption={false}
                                                        labelInValue={true}
                                                        optionLabelProp='label'
                                                        disabled={this.state.currentHotel ? true : false}
                                                        >
                                                        {hotel_options}
                                                    </Select>
                                                )}
                                            </FormItem>
                                        </div>
                                        : ''
                                    }

                                    <div className="col-md-4">
                                        <FormItem label="Cliente / Huésped" hasFeedback className="marginBottom10">
                                            {this.props.form.getFieldDecorator('client', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el cliente',
                                                }, {
                                                    validator: this.checkClient.bind(this)
                                                }]
                                            })(
                                                <Select 
                                                    size='large'
                                                    mode="combobox"
                                                    onChange={this.handleSelectClientChange.bind(this)}
                                                    filterOption={false}
                                                    labelInValue={true}
                                                    optionLabelProp='label'
                                                    disabled={this.props.params.clientId ? true : false}
                                                    >
                                                    {client_options}
                                                </Select>
                                            )}
                                        </FormItem>

                                        {this.props.form.getFieldValue('client') && this.props.form.getFieldValue('client').key 
                                            ? <Button type="primary" key="client_details" onClick={this.showClientDetails.bind(this)} className={'btn btn-primary btn-flat'}>Ver detalles</Button>
                                            : ''
                                        }
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-md-4">
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="box box-primary" style={{borderTopColor: this.props.app.currentHotel.color ? this.props.app.currentHotel.color : '#265f84'}}>
                            <div className="box-header with-border">
                                Datos de la Factura
                            </div>

                            <div className="box-body">
                                <div className="row">
                                    <div className="col-md-4">
                                        <FormItem label="# de Reservación" hasFeedback>
                                            {this.props.form.getFieldDecorator('reservation', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el número de reservación'
                                                }]
                                            })(<Input size='large' />)}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Check-In / Check-Out" hasFeedback>
                                            {this.props.form.getFieldDecorator('checkin_checkout', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija la fecha del check-in y check-out'
                                                }]
                                            })(
                                                <RangePicker 
                                                    showTime={{ format: 'HH:mm' }}
                                                    format="DD-MM-YYYY HH:mm"
                                                    onOk={resp => {
                                                        console.log(resp);
                                                    }} />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Método de pago" hasFeedback>
                                            {this.props.form.getFieldDecorator('payment_method', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, elija el método de pago'
                                                }]
                                            })(
                                                <Select size='large'>
                                                    <Option value="tarjeta">Tarjeta de crédio / débito</Option>
                                                    <Option value="efectivo">Efectivo</Option>
                                                    <Option value="deposito">Depósito bancario</Option>
                                                    <Option value="transferencia">Transferencia bancaria</Option>
                                                </Select>
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Monto a facturar" hasFeedback>
                                            {this.props.form.getFieldDecorator('amount', {
                                                rules: [{
                                                    required: true,
                                                    message: 'Por favor, ingrese el monto a facturar'
                                                }, {
                                                    validator: this.checkAmount.bind(this)
                                                }]
                                            })(
                                                <NumberFormat 
                                                    thousandSeparator={true} 
                                                    prefix={'$'} 
                                                    className="ant-input ant-input-lg" />
                                            )}
                                        </FormItem>
                                    </div>

                                    <div className="col-md-4">
                                        <FormItem label="Observaciones" hasFeedback>
                                            {this.props.form.getFieldDecorator('observations')(<TextArea rows={4} />)}
                                        </FormItem>
                                    </div>
                                </div>
                            </div>

                            <div className="row text-center paddingBottom30">
                                <Button type='primary' onClick={this.handleSubmit.bind(this)} loading={this.props.app.buttonLoading} className={'btn btn-primary btn-flat'}>
                                    Guardar
                                </Button>
                            </div>
                        </div>

                    </Form>
                </section>

                <Modal
                    visible={this.state.showModalClientDetails}
                    title="Detalles del Cliente"
                    onCancel={this.hideModalClientDetails.bind(this)}
                    footer={[
                        <Button key="back" onClick={this.hideModalClientDetails.bind(this)}>Cerrar</Button>,
                        <Button key="details" type="primary">
                            <Link to={`/clients/details/${this.state.currentClient ? this.state.currentClient.objectId : ''}`}>
                                Editar información
                            </Link>
                        </Button>
                    ]}
                >
                    {this.state.currentClient
                        ? <div>
                            <Card title="Datos Fiscales" className="marginBottom20">
                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Nombre completo, denominación o razón social:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.name}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Tipo de persona:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.type}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        RFC:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.rfc}
                                    </div>
                                </div>
                            </Card>

                            <Card title="Domicilio">
                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Calle:
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.street}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Número exterior
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.exterior_number}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Colonia
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.colony}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Número interior
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.interior_number}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Localidad
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.locality}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Referencia
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.reference}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Municipio
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.town}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        País
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.country}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Estado
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.state}
                                    </div>
                                </div>

                                <div className="row">
                                    <div className="col-sm-5 text-bold">
                                        Código Postal
                                    </div>
                                    <div className="col-sm-7">
                                        {this.state.currentClient.zip}
                                    </div>
                                </div>
                            </Card>
                        </div>
                        : ''
                    }
                </Modal>
            </div>
        )
    }
}

InvoiceNew.contextTypes = {
    router: PropTypes.object.isRequired
}

export default connect(({invoice, app}) => ({invoice, app}))(Form.create()(InvoiceNew))


// WEBPACK FOOTER //
// ./src/components/invoices/invoiceNew.js